import * as lazy from "./lazyRouteComponents";

export default [
  {
    path: "",
    name: "brapp:dashboard",
    component: lazy.DashboardIndex
  },
  {
    path: "briefs",
    name: "briefList",
    component: lazy.BriefList
  },
  {
    path: "briefs/new",
    name: "briefCreate",
    component: lazy.CreateBrief
  },
  {
    path: "briefs/:briefId/edit",
    name: "briefEdit",
    component: lazy.EditBrief
  },
  {
    path: "briefs/:briefId/report",
    name: "briefReport",
    component: lazy.BriefReport
  },
  {
    path: "alerts",
    name: "alertList",
    component: lazy.AlertList
  },
  {
    path: "alerts/new",
    name: "alertCreate",
    component: lazy.CreateAlert
  },
  {
    path: "alerts/:alertId/edit",
    name: "alertEdit",
    component: lazy.EditAlert
  },
  {
    path: "issues/overview",
    name: "issueOverview",
    component: lazy.IssueOverview
  },
  {
    path: "issues/types",
    name: "issueTypes",
    component: lazy.IssueTypes
  },
  {
    path: "issues",
    name: "issueList",
    component: lazy.IssueList
  },
  {
    path: "recognise/overview",
    name: "recognitionOverview",
    component: lazy.RecognitionOverview
  },
  {
    path: "recognise",
    name: "recognitionList",
    component: lazy.RecognitionList
  },
  {
    path: "reports",
    name: "reports",
    component: lazy.ReportsIndex
  },
  {
    path: "sales/products",
    name: "brapp:sales:productList",
    component: lazy.ProductList
  },
  {
    path: "sales/products/new",
    name: "brapp:sales:productCreate",
    component: lazy.CreateProduct
  },
  {
    path: "sales/products/:productId/edit",
    name: "brapp:sales:productEdit",
    component: lazy.EditProduct
  },

  {
    path: "sales/locations",
    name: "brapp:sales:locationList",
    component: lazy.LocationList
  },
  {
    path: "sales/locations/new",
    name: "brapp:sales:locationCreate",
    component: lazy.CreateLocation
  },
  {
    path: "sales/locations/:locationId/edit",
    name: "brapp:sales:locationEdit",
    component: lazy.EditLocation
  },

  {
    path: "sales/overview",
    name: "brapp:sales:overview",
    component: lazy.SalesOverview
  },
  {
    path: "sales/categories",
    name: "brapp:sales:categoryList",
    component: lazy.CategoryList
  },
  {
    path: "sales/categories/new",
    name: "brapp:sales:categoryCreate",
    component: lazy.CreateCategory
  },
  {
    path: "sales/categories/:categoryId/edit",
    name: "brapp:sales:categoryEdit",
    component: lazy.EditCategory
  }
];
